<table-list [resource]="termoDeUsoResource" [service]="termosDeUsoService"></table-list>